/**
 * @param onClick {() => void}
 * @returns {void}
 */
module.exports = function listenForForm1262ReturningUserCtaClicks(onClick) {
    document.querySelectorAll('[data-component="form-1262-returning-user-cta"]').forEach(returningUserCta => {
        returningUserCta.onclick = (e) => {
            e.preventDefault();
            onClick();
        };
    });
};